export default __webpack_public_path__ + "static/media/thriller.bc78861f.jpg";